import patsnapPopupManager from '@patsnap-ui/extensions/lib/utils/popup/popup-manager';
// FIXME 外层element-ui版本升级为2.x后删除
// FIXME 外层element-ui版本升级为2.x后删除
// FIXME 外层element-ui版本升级为2.x后删除
import elPopupManager from 'element-ui-2/lib/utils/popup/popup-manager';

// 使patsnap-ui跟element-ui的 zIndex保持一致;
export default function hackPopupManager() {
    if (!elPopupManager || !patsnapPopupManager) return;
    const originPatsnapPopupManagerZIndex = patsnapPopupManager.zIndex;
    const originPatsnapPopupManagerSetIndexMethod = patsnapPopupManager.nextZIndex;

    try {
        patsnapPopupManager.zIndex = elPopupManager.zIndex;
        patsnapPopupManager.nextZIndex = function nextZIndex() {
            return elPopupManager.zIndex++;
        };
    } catch (error) {
        console.warn('Hack z-index failed', error);
        patsnapPopupManager.zIndex = originPatsnapPopupManagerZIndex;
        patsnapPopupManager.nextZIndex = originPatsnapPopupManagerSetIndexMethod;
    }
}
